import React from 'react';
import { generateCallSign } from '../../../utils/engine/ProbabilityUtils';

// Constants
const CURSOR_BLINK_RATE = 500;
const LETTER_FADE_DELAY = 750;

export const drawCallSign = (p5, {
  typing,
  currentCallSign,
  currentLetter,
  cursorVisible,
  cursorBlinkTime
}) => {
  if (!typing || !currentCallSign) return;
  p5.textSize(64);
  p5.textFont('IBM BIOS');
  p5.textAlign(p5.LEFT, p5.CENTER);

  // Calculate total width for centering
  const totalWidth = p5.textWidth(currentCallSign);
  const startX = p5.width/2 - totalWidth/2;
  const y = p5.height/2;

  // Draw each revealed letter with glow effect
  for (let i = 0; i < currentLetter; i++) {
    const x = startX + p5.textWidth(currentCallSign.substring(0, i));
    const char = currentCallSign[i];
    
    // Glow effect
    p5.fill(0, 255, 0, 0.2);
    p5.text(char, x + 1, y + 1);
    p5.text(char, x - 1, y - 1);
    
    // Main text
    p5.fill(0, 255, 0);
    p5.text(char, x, y);
  }

  // Draw cursor
  if (cursorVisible && currentLetter < currentCallSign.length) {
    const cursorX = startX + p5.textWidth(currentCallSign.substring(0, currentLetter));
    const nextChar = currentCallSign[currentLetter];
    const charWidth = p5.textWidth(nextChar);
    const charHeight = p5.textAscent() + p5.textDescent();
    
    p5.noStroke();
    // Outer glow
    p5.fill(0, 30, 0, 255 * 0.3);
    p5.rect(cursorX - 2, y - charHeight/2 - 4, charWidth + 4, charHeight + 8);
    // Middle layer
    p5.fill(0, 50, 0, 255 * 0.4);
    p5.rect(cursorX - 1, y - charHeight/2 - 2, charWidth + 2, charHeight + 4);
    // Inner highlight
    p5.fill(0, 255, 0, 255 * 0.7);
    p5.rect(cursorX, y - charHeight/2, charWidth, charHeight);
    const cursorY = p5.height/2;
    
    p5.noStroke();
    p5.fill(0, 30, 0, 255 * 0.3);
    p5.rect(cursorX - 2, cursorY - charHeight/2 - 4, charWidth + 8, charHeight + 8);
    p5.fill(0, 50, 0, 255 * 0.4);
    p5.rect(cursorX, cursorY - charHeight/2 - 2, charWidth + 4, charHeight + 4);
    p5.fill(0, 255, 0, 255 * 0.7);
    p5.rect(cursorX + 2, cursorY - charHeight/2, charWidth, charHeight);
  }
};

export const INITIAL_STATE = {
  currentCallSign: '',
  currentLetter: 0,
  typing: false,
  lastUpdateTime: 0,
  cursorVisible: true,
  cursorBlinkTime: 0
};

export { CURSOR_BLINK_RATE, LETTER_FADE_DELAY };